const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速播放引擎',
    desc: '桔子影视采用自研视频加速技术，多 CDN 节点智能调度。无论您身在何处，都能享受秒开不缓冲的流畅观影体验。支持断点续播、记忆播放进度。',
    color: 'text-primary-600 bg-primary-100',
  },
  {
    icon: 'ri-shield-star-line',
    title: '安全稳定可靠',
    desc: '平台所有内容经严格筛选，无弹窗广告、无恶意跳转。桔子影视承诺永久免费，不做任何隐性收费，为您打造干净纯粹的追剧环境。',
    color: 'text-accent-600 bg-accent-100',
  },
  {
    icon: 'ri-device-line',
    title: '全平台覆盖',
    desc: '桔子影视完美适配 PC、平板与手机浏览器，同时提供 iOS / Android 原生客户端。一个账号（无需注册）跨设备同步片单与播放进度。',
    color: 'text-secondary-600 bg-secondary-100',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <p className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
            <i className="ri-star-line text-sm w-4 h-4 flex items-center justify-center"></i>
            核心优势
          </p>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">为什么选择桔子影视</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">三大核心能力，为您带来与众不同的追剧体验。</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {features.map((feat) => (
            <div key={feat.title} className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/60 text-center group hover:border-primary-200 transition-colors cursor-pointer">
              <div className={`w-16 h-16 mx-auto flex items-center justify-center rounded-2xl ${feat.color} mb-5`}>
                <i className={`${feat.icon} text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-3">{feat.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}